import { render, staticRenderFns } from "./Service_List.vue?vue&type=template&id=23697fe0&scoped=true&"
import script from "./Service_List.vue?vue&type=script&lang=js&"
export * from "./Service_List.vue?vue&type=script&lang=js&"
import style0 from "./Service_List.vue?vue&type=style&index=0&id=23697fe0&scoped=true&lang=css&"
import style1 from "./Service_List.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23697fe0",
  null
  
)

export default component.exports